import config from "./Configs";

export const RoutePath = {
    DEFAULT: '/',
    HOMEPAGE: '/main',
    LOGIN: '/login',
    REGISTRATION: '/registration',
    ACCOUNT_VERIFICATION: '/account-verification',
    FORGOT_PASSWORD: '/forgot-password',
    HOME: '/home',
    MAINTENANCE: '/maintenance',
    PROMOTIONS: '/promotions/:categoryId?/:customUrl?',
    PROMOTIONDETAILS: '/promotiondetails/:promotionId/:customUrl?',
    PROMOTION_PREVIEW: '/promotion/preview/:promotionId',
    NOT_FOUND: '/404',

    RGS_TOURNAMENTS: '/tournaments*',
    GAMIFICATION: '/gamification',
    METRA: '/metra',

    TOURNAMENTS: '/game-tournaments/:tab?',
    SINGLE_TOURNAMENTS: '/game-tournament/:tournamentId/:tab?',

    SPORT: '/sport/:page?/:targetId?/:targetName*',
    SPORT2: '/sport2/:page?/:targetId?/:targetName?',
    // SPORT_DETAILED: '/sport/:page?/:eventID?/:champID?',
    SPORTBETHISTORY: '/sport/BetsHistory/',
    ESPORT: '/esport/:page?/:targetId?/:targetName*',
    LIVETV: '/live-tv',

    CASINO: '/casino/:catId?/:subCatId?',
    CASINO_ALTERNATIVE: '/playin/:catId?/:subCatId?',

    LIVECASINO: '/livecasino/:groupId?/:categories?/:tab?',
    LIVECASINO_ALTERNATIVE: '/liveplayin/:groupId?/:categories?/:tab?',

    CASINOLOBBY: '/casino-lobby/:groupId?/:categories?/:tab?',
    CASINOLOBBY_ALTERNATIVE: '/playin-lobby/:groupId?/:categories?/:tab?',

    TVGAMESLOBBY: '/tvgames-lobby/:groupId?/:categories?/:tab?',
    VIRTUALSPORTLOBBY: '/virtualsport-lobby/:groupId?/:categories?/:tab?',
    FASTGAMESLOBBY: '/fastgames-lobby/:groupId?/:categories?/:tab?',
    GAME: '/game/:demo/:page/:providerId/:name/:catId?/:subCatId?',
    GAME_INFO: '/info/:page/:providerId/:name',
    SELF_ASSESSMENT: '/self-assessment',

    // LIVE_CASINO_GAME: '/livecasino-game/:providerId/:name',
    // LIVE_CASINO_ALTERNATIVE: '/livecasino-game/:providerId/:name',

    PLAY_GAME: '/play/:page/:providerId/:name/:mode?/:demo?/:gameId?',
    PLAY_GAME_FULL: '/play-fullscreen/:page/:providerId/:name/:demo?/:gameId?',
    PLAY_GAME_MOBILE: '/play-mobile/:page/:providerId/:name/:demo?/:gameId?',
    COMPLIENT_FORM: '/complaint-form',
    COMPLAINTS_HISTORY: '/complaints-history',

    // GAME: '/game/:demo/:providerId/:id',
    GAMELAUNCH: '/games/:gameId',
    TV_GAMES: '/tv-games/:gameId?',
    FAST_GAMES: '/fast-games',
    GLOBAL_BET: '/global-bet',
    BETRADAR: '/betradar/:game?',
    PAGES: '/pages/:pageId/:pageContent?',
    PROMO_TOOL: '/promo/:promoName',
    THUNDERBITE: '/thunderbite',
    EXCHANGE_CENTER: '/exchange-center',
    REGISTRATION: '/registration',

    POPUP_SUFFIX: '/(popup)?/:popupName?/:popupid?',
    POPUP_SUFFIX_PARAMS: '/(popup)?/:popupName?/:popupid?/:param1?',

    POPUP: `/*/popup/:popupName/:id?/:param1?/:param2?`,
    REGISTRATION_POPUP: `/*/popup/registration/:id?/:param1?/:param2?`,
    FORGOT_POPUP: `/*/popup/forgotpassword/:id?/:param1?/:param2?`,
    FORGOT_USERNAME: `/*/popup/forgotusername/:id?/:param1?/:param2?`,
    LOGIN_POPUP: `/*/popup/login/:id?/:param1?/:param2?`,
    JOIN_POPUP: `/*/popup/join/:id?/:param1?/:param2?`,
    CUPIS_OTP_POPUP: `/*/popup/cupisotp`,
    CHANGE_POPUP: `/*/popup/changepassword/:id?/:param1?/:param2?`,
    PROFILE_POPUPS: `/*/popup/(myprofile|cashier|offers|twofactorauth|activesessions|trustedbrowsersreport|cashiersettings|casinobonuses|mybonuses|campaign|sportbonuses|realmoneybonuses|bonuses|freespins|messages|gamehistory|tournaments|referrerreport|withdrawal|transaction|withdrawalhistory|documents|identification|preferences|${config.NEW_PLAT ? 'passkey|activitylog|accountclosure|betlimit|timeout|selfexclusion|accesslimit|responsiblegaming|losslimit|prizeshistory|nsep|timelimit|' : ''}realitycheck|depositlimit|selfexclusion|timeout|deposithistory|bonushistory|promocodes|invitefriend|statustracking)/:id?/:param1?/:param2?`,
    PROMOTIONS_POPUP: `/*/popup/promotions/:id?/:param1?/:param2?`,
    CUSTOM_POPUP: `/*/popup/ad/:popupAlias?/:isPreview?`,
    ACCOUNTMENU_POPUP: `/*/popup/accountmenu`,
    PAYDROM_WALLET_POPUP: `/*/popup/wallet/:type?`,


    // OPEN_PAYMENT_FORM: '/posting/:data',
    RULES: '/rules/:menuId?/:subMenuId?/:pageContent?',
    REGULATIONS: '/regulations/:menuId?/:subMenuId?',
    PAYMENT: '/cashier/:type?/:history?',
    // TODO make PAYMENT same as APP_PAYMENT then switch
    APP_PAYMENT: '/app-cashier/:type?/:id?',
    PAYMENT_SUBMIT: '/payment-submit',
    PAYMENT_SUBMIT_2: '/payment-submit-2',

    //CUPIS RSS FEEDS
    CUPIS_FEED: '/cupis/:feedType(1|2)',
    WIDGET_EDITOR: '/widget-editor/:type?/:id?',
    WIDGET_PREVIEW: '/widget-preview/:type/:previewWidgetId',

    BONUS_CAMPAIGN_JOIN: '/campaign/:campaignId/:popup?/:login?/:id?/',

    AGENT_LOGIN: '/auth/agent/:token?',

    //LOBBY HOMEPAGES

    CASINOLOBBYHOME: '/casino-home/:groupId?/:categories?/:tab?',
    LIVECASINOHOME: '/livecasino-home/:groupId?/:categories?/:tab?',
    TVGAMESLOBBYHOME: '/tvgames-home/:groupId?/:categories?/:tab?',
    VIRTUALSPORTLOBBYHOME: '/virtualsport-home/:groupId?/:categories?/:tab?',
    FASTGAMESLOBBYHOME: '/fastgames-home/:groupId?/:categories?/:tab?',

};

export const RestPath = {

    //Login
    LOGIN: '/token',
    GET_LOGIN_INFO: '/Account/LoginPlayerInfo',
    GET_TOKEN: '/Account/GetToken',
    
    COMPLAINTS: '/PlayerComplaints',
    COMPLAINTS_HISTORY:'/reportingsite/PlayerComplaints/History',
    COMPLAINT_DETAILS: '/reportingsite/PlayerComplaints',
    

    
    //UI Control Tree
    GET_CONTROLS: '/UICustomization/GetControlsTree',
    GET_ONE_CLICK_REGISTRATION: '/UiCustomization/OneClickRegistration',
    EXPORT_ONE_CLICK_PDF: '/Account/ExportOneClickCredentialsPDF',
    //Setings
    GET_REGISTRATION_SETTINGS: '/ProjectSettings/GetRegistrationSettings',
    GET_LOGIN_SETTINGS: '/ProjectSettings/GetLoginSettings',
    GET_PROFILE_SETTINGS: '/ProjectSettings/GetProfileSettings',
    GET_SETTINGS: '/ProjectSettings/GetSettings',
    //GET_SETTINGS: '/ProjectSettings/Settings.json',
    GET_COUNTRIES: '/ProjectSettings/GetCountries',
    GET_NSEP: '/ProjectSettings/Nsep',
    GET_CITIES: '/ProjectSettings/GetCities',
    GET_REGIONS: '/ProjectSettings/GetRegions',
    LIMIT_PREDIFINED_VALUES: '/ProjectSettings/GetLimitPredifinedValues',
    GET_GENDERS: '/System/GetGenders',
    GET_PLAYER_DATA: '/Account/GetPlayerData',
    GET_PLAYER_ADDITIONAL_INFO: '/PlayerInfo/GetPlayerAdditionalInfo',
    GET_ACCOUNT_WALLETS: '/Account/GetAccountWallets',
    GET_PLAYER_WALLETS: '/TransactionSiteService/Account/PlayerWallets',
    GET_PLAYER_BALANCE: config.NEW_PLAT ? '/Account/GetAccountBalances': '/Account/GetAccountBalance',
    GET_ACCOUNT_BALANCE: '/TransactionSiteService/Account/AccountBalance',
    GET_SPORT_TOKEN: '/Sport/Login',
    GET_BUSINESS_RULES: '/BusinessRule/GetRules',

    //Casino games
    GET_GAME_CATEGORIES: '/Game/GetCategories',
    VERIFY_REGISTRATION_DATA: '/Account/VerifyRegistrationData',
    GET_GAMES: '/Game/GetGames',
    GET_RECENT_GAMES: '/Game/GetRecentGames',
    GET_RANDOM_GAMES: '/Game/GetRandomGames',

    GET_TOP_WINNERS: '/Statistics/GetTopWinners',
    GET_CLIENT_TOP_WINNERS: '/Statistics/GetClientTopWinners',
    GET_CLIENT_TOP_WINNERS_WIDGET: '/lobby/GetLobbyIdsWithTopWinnersWidget',
    GET_LOBBY_WIDGETS_BY_IDS: '/lobby/GetTopWinnersWidgetByLobbyIds',
    GET_LOBBY_IDS: '/Lobby/GetLobbyIdsWithTopWinnersWidget',
    GET_CASINO_TOP_JACKPOTS: '/Statistics/GetJackpot',

    //Game Launch
    GET_GAME_LAUNCH: '/Game/Launch',
    GET_GAME_LAUNCH_DEMO: '/Game/LaunchDemo',
    //Seo Settings
    GET_SEO_SETTINGS: '/SEO/GetPageSettings',
    GET_RULES_SEO_SETTINGS: '/SEO/GetRulesSettings',
    GET_SEO_SCHEMA: '/SEO/GetSchema',
    GET_SEO_MATCH_RULES: '/SEO/MatchRules',
    GET_SEO_CONTENT: '/SEO/Content',

    // Account verification
    VERIFY_EMAIL: '/Account/VerifyEmail',
    RESEND_EMAIL_VERIFICATION: '/Account/ResendEmailVerification/',
    VERIFY_MOBILE: '/Account/VerifyMobile',
    RESEND_MOBILE_VERIFICATION: '/Account/ResendMobileVerification',
    SEND_REGISTRATION_VERIFICATION_CODE: '/Account/SendRegistrationVerificationCode',
    SEND_LOGIN_VERIFICATION_CODE: '/Account/SendLoginVerificationCode',
    CONFIRM_REGISTRATION_VERIFICATION_CODE: '/Account/ConfirmRegistrationVerificationCode',
    CHECK_CLIENT_CUPIS_STATUS: '/Account/CheckClientCupisStatus',
    CHECK_CLIENT_CUPIS_STATUSV2: '/Account/CheckClientCupisStatusV2',
    IDENTIFY_CUPIS_CLIENT: '/Account/IdentifyCupisClient',
    GET_CUPIS_CLIENT_INN: '/Account/GetClientINN',
    EDIT_CUPIS_CLIENT_BIRTHDATE: '/Account/EditClientBirthdate',
    CUPIS_SIMPLE_IDENTIFY: '/Account/VerifyClientCupisSimple',
    GET_SIMPLE_CUPIS_ESIA: '/Account/VerifyClientCupisSimpleEsia',
    GET_SIMPLE_VERIFICATION_URL: '/Account/CheckCupisVerificationSession',
    VERIFY_FULL_CUPIS_ESIA: '/Account/VerifyClientCupisFullEsia',
    VERIFY_CUPIS_TINKOFF: '/Account/VerifyClientCupisTinkoff',
    VERIFY_CUPIS_PSP: '/Account/VerifyClientCupisPSP',

    // End session
    END_SESSION: '/Account/EndSession',

    // Account Registration
    USER_REGISTRATION: '/Account/Register',
    ONE_CLICK_USER_REGISTRATION: '/Account/OneClickRegister',
    USER_REGISTRATION_RUSSIAN_MARKET: '/Account/RegisterForRussianMarket',
    SEND_ONE_CLICK_CREDENTIALS_EMAIL: '/Account/SendOneClickCredentialsViaEmail',
    FIREBASE_REGISTRATION: '/Account/FirebaseRegistration',

    // Account check registration data
    CHECK_REGISTRATION_DATA: '/Account/CheckData',

    // Edit Profile
    EDIT_PROFILE: '/Account/EditProfile',

    // My Profile
    GET_DEPOSITS: '/Transaction/GetDeposits',
    GET_WITHDRAWALS: '/Transaction/GetWithdrawals',
    GET_TOURNAMENTS_HISTORY: '/Tournament/GetTournamentsHistory',
    GET_BETS_HISTORY: '/Transaction/GetBetsHistory',
    GET_BALANCE_ADJUSTMENTS_HISTORY: '/Transaction/GetBalanceAdjustmentsHistory',
    CANCEL_WITHDRAWAL: '/Transaction/CancelWithdrawals',
    CONFIRM_DEPOSIT: '/Transaction/ConfirmDeposit',
    GET_SPORT_JACKPOT_HISTORY: '/Transaction/GetSportJackpotHistory',
    GET_CURRENCY_SPECEFIC_SETTINGS: '/Transaction/GetCurrencySpecificSettings',

    GET_PAYMENT_GROUPS: '/Payment/Cashier',
    CASHIER_DEPOSIT: '/Payment/Payment/DepositPaymentRequest',
    CASHIER_WITHDRAWAL: '/Payment/Payment/WithdrawalPaymentRequest',
    CASHIER_DEPOSIT_RECEIPT: '/Payment/Payment/Receipt',
    CASHIER_PAYMENT_LIMITS: '/Payment/Cashier/PlayerLimits',
    CASHIER_LAUNCH: '/Payment/Cashier/Launch',

    GET_PAYMENT_SYTEMS: '/PaymentSystem/GetPaymentSystemsByClient',
    DO_WITHDRAWAL: '/Transaction/Withdrawal',
    DO_DEPOSIT: '/Transaction/Deposit',
    CONVERT_PAYMENT_REQUEST: '/Transaction/ConvertPaymentRequest',
    GET_REFERRER_HISTORY: '/Transaction/GetReferrerHistory',
    GET_REFERRER_REPORT: '/Transaction/GetReferrerReport',
    GET_TRANSACTION_INFO: '/Transaction/GetTransactionInfo',
    GET_CASHBACK_HISTORY: '/Transaction/GetCashbackHistory', // centrivo API
    GET_BUY_ACTIVATION_HISTORY: '/Transaction/GetBuyActivationHistory', // centrivo API
    GET_CASINO_JACKPOT_HISTORY: '/ReportingSite/WalletTransaction/GetCasinoJackpotHistory',
    GET_TRANSACTION_BONUSES_HISTORY: '/Transaction/GetBonusHistory',
    GET_PAYMENT_REQUESTS_COMMISSIONS: '/Transaction/GetPaymentRequestsCommission',
    NOTIFICATION_PREFERENCES: '/Account/NotificationPreferencesSettings',
    NOTIFICATION_PREFERENCES_RULES: '/Notification/NotificationPreferences',
    SEND_2FA_CODE: '/Account/VerificationCode',
    SEND_CUPISV2_CODE: '/Account/SendCupisV2LoginVerificationCode',
    CHECK_CUPISV2_CODE: '/Account/CheckCupisV2LoginVerificationCode',
    SEND_LOGGEDIN_USER_2FA_CODE: '/Account/AccountVerificationCode',
    CUPIS_FEED: '/Account/GetRssFeeds',
    KYCAID_REQUEST: '/Account/VerifyIdentity',
    ACCOUNT_CLOSURE: '/Account',
    DEPOSIT_LIMIT: '/PlayerService/ResponsibleGaming/Deposit',
    BET_LIMIT: '/PlayerService/ResponsibleGaming/Bet',
    SINGLE_BET: '/PlayerService/ResponsibleGaming/SingleBet',
    TIME_LIMIT: '/PlayerService/ResponsibleGaming/Time',
    ACCESS_LIMIT: '/PlayerService/ResponsibleGaming/AccessLimit',
    ACCESS_LIMIT_OVERVIEW: '/PlayerService/ResponsibleGaming/AccessLimitOverview',
    ACCESS_LIMIT_PENDING: '/PlayerService/ResponsibleGaming/AccessLimitPending',
    GET_TIME_OUT: '/PlayerService/ResponsibleGaming/Limit/Timeout',
    SET_TIME_OUT: '/PlayerService/ResponsibleGaming/Timeout',
    GET_SELF_EXCLUSION: '/PlayerService/ResponsibleGaming/Limit/SelfExclusion',
    SET_SELF_EXCLUSION: '/PlayerService/ResponsibleGaming/SelfExclusion',  
    LOSS_LIMIT: '/PlayerService/ResponsibleGaming/Loss',
    PROMPT_LIMIT: '/PlayerService/ResponsibleGaming/SetPromptLimits',
    EXCLUSION_REASONS: '/Account/Reasons',
    GET_SECURITY_CODE: '/PlayerSecurity/GenerateSetupCode',
    ENABLE_AUTH: '/PlayerSecurity/EnableAuthenticator',
    DISABLE_AUTH: '/PlayerSecurity/DisableAuthenticator',
    LOG_HISTORY: '/Account/Sessions/History',
    SESSION_HISTORY: '/Account/GetSessionsHistory',
    QUIT_SESSIONS: '/Account/QuitSessions',
    RESEND_TRUSTED_CODE: '/Account/ResendTrustedCode',
    ENABLE_TRUSTED_DEVICE: '/Account/EnableTrustedDevice',
    GET_TRUSTED_DEVICES: '/Account/ClientTrustedDevices',
    GET_REGISTERED_PASSKEYS: '/Account/Passkeys',
    GET_REGISTERED_PASSKEYS_OPTIONS: '/Account/PasskeyRegisterOptions',
    SET_UP_PASSKEY: '/Account/PasskeyRegister',
    DELETE_PASSKEY: '/Account/Passkey',
    PASSKEY_LOGIN: '/Account/PasskeyLogin',
    GET_LOGIN_PASSKEY_OPTIONS: '/Account/PasskeyLoginOptions',
    LOGIN_WITH_PASSKEY: '/Account/PasskeyLogin',
   
  

    GET_REALITY_CHECK: '/PlayerService/ResponsibleGaming/Limit/RealityCheck',
    SET_REALITY_CHECK: '/PlayerService/ResponsibleGaming/RealityCheck',
    // Messages
    // GET_CLIENT_MESSAGES: '/Message/GetClientMessages',
    // GET_CLIENT_UNREAD_MESSAGES_COUNT: '/Message/GetClientUnreadMessagesCount',
    // READ_CLIENT_MESSAGE: '/Message/ReadClientMessage',
    // SAVE_MESSAGE: '/Message/SaveMessage',
    // DELETE_MESSAGE: '/Message/DeleteClientMessage',

    // Messages
    GET_CLIENT_MESSAGES: '/Message/Get',
    GET_MESSAGE_CHAIN: '/Message/Messages',
    GET_CLIENT_UNREAD_MESSAGES_COUNT: '/Message/UnreadesCount',
    READ_CLIENT_MESSAGE: '/Message/Read',
    SAVE_MESSAGE: '/Message/Send',
    DELETE_MESSAGE: '/Message/Delete',

    GET_BONUSES: '/Bonus/GetBonuses',
    GET_BONUS_HISTORY: '/Bonus/GetBonusesHistory',
    GET_PRIZES_HISTORY: '/PromoSite/Promotions/Prizes',
    GET_BONUS_GAMES: '/Bonus/GetBonusGames',
    ACTIVATE_PROMO_CODE: '/Bonus/ActivateBonusByPromoCode',
    ACTIVATE_PROMO_CODE_V2: '/BonusService/PromoCode/ActivatePromoCode',
    GET_BONUS_CAMPAIGNS: '/Bonus/GetClientBonusCampaigns',
    GET_BONUS_DETAILS: '/Bonus/GetClientBonusCampaignDetails',
    GET_BONUS_PRODUCTS: '/Bonus/GetClientBonusCampaignProducts',
    GET_BONUS_SPORTS: '/Bonus/GetClientSportsBonus',
    GET_BONUS_TOURNAMENTS: '/Bonus/GetClientBonusTournaments',
    GET_BONUS_EVENTS: '/Bonus/GetClientBonusEvents',
    GET_CLIENT_BONUS_HISTORY: '/Bonus/GetClientBonusHistory',
    GET_CLIENT_LINKED_BONUSES: '/Bonus/GetClientLinkedBonusesByIterationKey',
    GET_ATTACHED_BONUS_INFO: '/Bonus/GetAttachedBonusInfo',

    GET_BONUS_SYSTEM: '/BonusService/Bonus/Bonuses',
    GET_BONUS_SYSTEM_DETAILS: '/BonusService/Bonus/Bonuses',
    GET_BONUS_SYSTEM_PRODUCTS: '/TransactionSiteService/Bonus/BonusGames',
    GET_BONUS_SYSTEM_ATTACHED_BONUS: '/BonusService/Bonus/Units',

    BONUS_HISTORY: '/Bonus/BonusHistory',
    BONUS_DETAILS: '/Bonus/Bonuses',
    BONUS_GAMES: '/TransactionSiteService/Bonus/BonusGames',


    // Offers
    GET_OFFERS: '/CampaignService/Offers',
    GET_BONUS_SYSTEM_DETAILS: '/BonusService/Bonus/Bonuses',
    GET_OFFER_PRODUCTS: '/TransactionSiteService/Bonus/Offers',


    CHANGE_CLIENT_BONUS_WALLET_STATE: '/Bonus/ChangeClientBonusWalletState',
    GET_CLIENT_BONUS_WALLET_STATE: '/Bonus/GetClientBonusWalletState',
    ACTIVATE_BONUS_CAMPAIGN: '/Bonus/ActivateClientBonusCampaign',
    CANCEL_BONUS_CAMPAIGN: '/Bonus/CancelClientBonusCampaign',
    GET_CLIENT_ACTIVE_BONUS_SETTINGS_COUNT: '/Bonus/GetClientActiveBonusSettingsCount',
    GET_BONUS_REQUEST_ITEMS: '/Bonus/CampaignsForRequest',

    PAUSE_CLIENT_BONUS_CAMPAIGN: '/Bonus/PauseClientBonusCampaign',
    RESUME_CLIENT_BONUS_CAMPAIGN: '/Bonus/ResumeClientBonusCampaign',

    BONUS_CAMPAIGN_PAGE: '/Campaign/',
    
    // Translations
    GET_TRANSLATIONS: '/Translation/GetTranslations',

    // Banners
    GET_BANNERS: '/Image/GetImages',
    GET_IMAGES: '/Image/GetImageSources',

    // Captcha
    GENERATE_CAPTCHA: '/Captcha/Generate',

    // Upload File
    UPLOAD_FILE: '/Account/UploadFile',
    GET_PLAYER_DOCUMENT_STATES: '/Account/GetPlayerDocumentStates',

    // KYC

    KYC: '/PlayerService/Kyc',
    LegalAgreement: '/PlayerService/LegalAgreement',

    // Promotions
    GET_PROMOTIONS_CATEGORIES: '/Promotion/GetCategories',
    GET_PROMOTIONS: '/Promotion/GetPromotions',
    GET_PROMOTION: '/Promotion/GetPromotion',
    GET_RANDOM_PROMOTIONS: '/Promotion/GetRandomPromotions',
    GET_HIGHLIGHT_PROMOTIONS: '/Promotion/HighlightsPromotions',



    // Tournaments
    GET_TOURNAMENTS: '/Tournament/GetTournaments',
    GET_TOURNAMENT: '/Tournament/GetTournament',
    GET_TOURNAMENT_GAMES: '/Tournament/GetTournamentGames',
    JOIN_TOURNAMENT: '/Tournament/Join',

    //RGS Tournaments
    GET_RGS_TOURNAMENT_LAUNCH_URL: '/TransactionSiteService/RgsTournament/Launch',
    GET_RGS_WIDGET_LAUNCH_URL: '/Rgs/AuthenticationToken',
    //Gamification
    GET_GAMIFIACTION_LAUNCH_URL: '/Gamification/Launch',
    GET_GAMIFIACTION_THUNDERBITE_URL: '/Gamifications/ThunderBiteUrl',

    // Pages
    GET_PAGE: '/Page/Get',
    GET_BACKGROUNDS: '/Page/GetBackgrounds',

    //Location
    GET_LOCATION: '/ProjectSettings/GetCountryCode',
    GET_DORMANT_CODE: '/Account/DormantCode', // phoenix API

    FORGOT_PASSWORD: '/Account/ForgotPassword',
    RECOVER_PASSWORD: '/Account/RecoverPassword',
    FORGOT_USERNAME: '/Account/ForgotUsername',
    CHANGE_PASSWORD: '/Account/ChangePassword',
    CHANGE_AGENT_PASSWORD: '/Account/ChangeAgentPassword',
    REQUEST_CALLBACK: '/Account/OrderCallback',
    REQUEST_CHASHBACK: '/Account/RequestCashback',
    CHECK_CASHBACK: '/Account/CheckCashback',

    // Lobby
    GET_LOBBY_CATEGORIES: '/Lobby/GetCategories',
    GET_LOBBY_GROUPS: '/Lobby/GetGroups',
    GET_LOBBY_PRODUCTS: '/Lobby/GetProducts',
    GET_LOBBY_PRODUCT: '/Lobby/GetProduct',
    GET_JACKPOTWIDGET: '/Lobby/GetJackpotWidget',
    GET_LOBBY_WIDGETS: '/Lobby/GetWidgets',

    GET_LOBBY: '/Lobby/GetLobby',
    GET_FILTERS: '/Lobby/GetFilters',
    GET_MOST_LIKED_PRODUCTS: '/Lobby/GetMostLikedProducts',
    GET_LAST_PLAYED_PRODUCTS: '/Lobby/GetLastPlayedProducts',
    GET_TRENDING_PRODUCTS: '/Lobby/GetTrendingProducts',
    GET_LEFTBAR_PRODUCTS: '/Lobby/GetLeftBarProducts',
    GET_GAMES_SEO_PAGE_PRODUCTS: '/Lobby/GetGamesSeoPageProducts',
    GET_GAME_VIEW_PRODUCTS: '/Lobby/GetProductsInGameView',
    GET_MY_CASINO_GAMES: '/Lobby/GetMyCasinoGames',
    GET_PLAYER_LIKE_FAVORITE_GAMES: '/Lobby/GetPlayerLikeFavoriteGames',

    LIKE_PRODUCT: '/Lobby/LikeProduct',
    DISLIKE_PRODUCT: '/Lobby/DislikeProduct',
    ADD_FAVORITE_PRODUCT: '/Lobby/AddFavoriteProduct',
    REMOVE_FAVORITE_PRODUCT: '/Lobby/RemoveFavoriteProduct',

    GET_WIDGET: '/Widget/Get',
    GET_WIDGET_FOR_PREVIEW: '/Widget/GetForPreview',
    GET_WIDGET_TRANSLATION: '/Widget/Translation',
    GET_POPUP: '/Popup/Get',
    GET_POPUP_PREVIEW: '/Popup/GetPreview',

    GET_ANNOUNCEMENTS: '/Announcement/GetAnnouncements',

    GET_FREE_SPINS: '/Bonus/GetClientBonuseGamesReport',
    GET_FREE_SPINS_GAMES: '/Bonus/GetClientBonuseGames',

    GET_STORIES: '/UiBuilderService/StoryManagement',

    //Promo Tool
    GET_PROMO: '/PromoSite/Promotions',
    GET_PROMO_BALANCE: '/PromoSite/Promotions/Balance',
    GET_PROMO_SPIN_DATE: '/PromoSite/Promotions/NextSpinDate',
    GET_PROMO_PRIZE: '/PromoSite/Promotions/Spin',
    COLLECT_PROMO_SPINS: '/PromoSite/Promotions/CollectSpins',
    GET_PROMO_NEXT_SPINS_COLLECT: '/PromoSite/Promotions/NextSpinsCollect',
    GET_PROMO_BALANCE_INFO: '/PromoSite/Promotions/Balance/Validity',
    GET_EXCHANGE_CENTER: '/PromoSite/Promotions/ExchangeCenter',
    EXCHANGE_PRIZE: '/PromoSite/Promotions/ExchangeMaterialPrize',

    //ReferFriend
    GET_CLIENT_INVITES: '/ReferralProgram/ClientInvites',
    GET_CLIENT_GROUPS: '/ReferralProgram/Groups',
    GET_REFERRAL_BONUSES: '/ReferralProgram/Bonuses',
    GET_REFERRAL_BONUS_DETAILS: '/ReferralProgram/BonusDetails',
    INVITE_FRIEND: '/ReferralProgram/InviteFriend',
    INVITE_FRIEND: '/ReferralProgram/InviteFriend',
    CLAIM_GROUP: '/ReferralProgram/ClaimGroup',
    SEND_REFER_REMINDER: '/ReferralProgram/SendReminder',


    BUY_PROMO_SPINS: '/PromoSite/Promotions/BuyActivationsFromWallet',
    PROMO_TOOL_AUTO_SPIN: '/PromoSite/Promotions/SpinMany',

    //Lobby Home
    GET_LOBBY_HOME_WIDGETS: '/Lobby/LobbyHomeWidgets',
    GET_LOBBY_HOME_WIDGET_GAMES: '/Lobby/LobbyHomeWidgetGames',
    GET_LOBBY_HOME_ACTION_LINKS: '/Lobby/LobbyHomeWidgetActionLinks',
    GET_LOBBY_HOME_GAME_GROUPS: '/Lobby/LobbyHomeWidgetGameGroups',
    GET_LOBBY_HOME_PROVIDERS: '/Lobby/LobbyHomeWidgetProviders',
    GET_LOBBY_HOME_TOP_WINS: '/Lobby/LobbyHomeWidgetTopWins',
    GET_LOBBY_HOME_CONFIGS: '/Lobby/GetLobbyHomeConfigs',
    GET_LOBBY_HOME_NAV_BAR: '/Lobby/GetNavigationBarItems',
    GET_LOBBY_HOME_TOP_X: '/Lobby/LobbyHomeWidgetTopX',
    GET_LOBBY_HOME_SINGLE_GAME: '/Lobby/LobbyHomeWidgetSingleGame',
    GET_LOBBY_HOME_RANDOM_GAME: '/Lobby/LobbyHomeWidgetRandomGame',
    GET_LOBBY_HOME_RANDOM_GAMES: '/Lobby/LobbyHomeWidgetRandomGames',
    GET_LOBBY_HOME_WIDGET_PROVIDERS_WITH_GAMES: '/Lobby/LobbyHomeWidgetProvidersWithGames',
    GET_LOBBY_HOME_WIDGET_PROVIDER_GAMES: '/Lobby/LobbyHomeWidgetProviderGames',
    GET_SEARCH_POPUP_GROUPS: '/Lobby/GetGamesSearchPopupProducts',
    GET_LOBBY_HOME_GROUP: '/Lobby/GetGroup',
    GET_LOBBY_HOME_WIDGET_COLLECTIONS: '/Lobby/LobbyHomeWidgetCollectionItems',
    GET_LOBBY_HOME_WIDGET_IMAGES: '/Lobby/LobbyHomeWidgetImageItems',

    //Self Assessment
    GET_SELF_ASSESSMENT: '/reportingsite/PlayerSelfAssessments/Quiz',
    SEND_SELF_ASSESSMENT: '/reportingsite/PlayerSelfAssessments'
};
